<!-- splash screen -->
<div #splashScreen class="splash-screen">
  <img [src]="constants.applicationLogoDarkUrl" alt="Logo" />
</div>
